import React from 'react';
import './Dropdown.css';

export default function DashboardProducao() {
  const params = new URLSearchParams(window.location.search);
  const producaoId = params.get('producaoId');

  return (
    <div className="container-geral fundo-branco" style={{ padding: 20 }}>
      <h2 style={{ color: 'rgb(235, 133, 0)', textAlign: 'center', marginBottom: 20 }}>
        📊 Dashboard do Projeto {producaoId ? `#${producaoId}` : ''}
      </h2>
      <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 16 }}>
        Dashboard em construção...
      </div>
    </div>
  );
}
